// constants.jsx — shared tokens, config arrays, and pure helpers for the Clients module.
// No JSX/components here so it can be imported anywhere without cycles.

// ─── DESIGN TOKENS ───────────────────────────────────────────────────────────
// Aliases of the central theme — change colors in src/theme.js, not here.
import { BRAND_HEX, BRAND_LIGHT, BRAND_RING } from "../theme";
import { BRAND } from "../brand";
export const G = BRAND_HEX;     // brand color (real hex, safe for SVG stroke/fill)
export const GL = BRAND_LIGHT;  // light tint
export const GR = BRAND_RING;   // ring / border tint

// ─── CLIENT DETAIL MODAL TABS ────────────────────────────────────────────────
export const TABS = [
  {
    id: "profile",
    label: "Profile",
    icon: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  },
  {
    id: "trip",
    label: "Trip",
    icon: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064",
  },
  {
    id: "payment",
    label: "Payment",
    icon: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1",
  },
  {
    id: "refund",
    label: "Refund",
    icon: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6",
  },
  {
    id: "review",
    label: "Review",
    icon: "M11.48 3.5a.56.56 0 011.04 0l2.13 5.11a.56.56 0 00.48.35l5.52.44c.5.04.7.66.32.99l-4.2 3.6a.56.56 0 00-.18.56l1.28 5.39a.56.56 0 01-.84.61l-4.73-2.89a.56.56 0 00-.59 0l-4.72 2.89a.56.56 0 01-.84-.61l1.28-5.39a.56.56 0 00-.18-.56l-4.2-3.6a.56.56 0 01.32-.99l5.52-.44a.56.56 0 00.48-.35l2.13-5.11z",
  },
  { id: "flights", label: "Flights", icon: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8" },
  {
    id: "hotels",
    label: "Hotels",
    icon: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  },
  {
    id: "visa",
    label: "Visa",
    icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z",
  },
  {
    id: "services",
    label: "Services",
    icon: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm3 4h8M8 11h8M8 15h5",
  },
  {
    id: "servicesTimeline",
    label: "Timeline",
    icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
  },
  {
    id: "tasks",
    label: "Tasks",
    icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
  },
  {
    id: "notes",
    label: "Notes",
    icon: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
  },
];

// ─── REFUND STATUS COLORS ─────────────────────────────────────────────────────
export const REFUND_STATUS_COLOR = {
  pending: "bg-amber-100 text-amber-700",
  processing: "bg-blue-100 text-blue-700",
  processed: "bg-emerald-100 text-emerald-700",
  rejected: "bg-rose-100 text-rose-600",
};

// ─── PAYMENT STATUS COLORS ────────────────────────────────────────────────────
export const payStatusColor = {
  paid: "bg-emerald-100 text-emerald-700",
  partial: "bg-amber-100 text-amber-700",
  unpaid: "bg-rose-100 text-rose-600",
  refunded: "bg-sky-100 text-sky-700",
};

// ─── WIZARD STEPS ─────────────────────────────────────────────────────────────
// CLIENT_STEPS — full new-client wizard (personal + first trip).
export const CLIENT_STEPS = [
  { id: 1, label: "Personal", d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" },
  { id: 2, label: "Trip", d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064" },
  { id: 3, label: "Payment", d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1" },
  { id: 4, label: "Services", d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" },
  { id: 5, label: "Refund", d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" },
];

// TRIP_STEPS — single-trip add/edit wizard (no personal step). Renders Step2..Step5.
export const TRIP_STEPS = [
  { id: 1, label: "Trip", d: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064" },
  { id: 2, label: "Payment", d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1" },
  { id: 3, label: "Services", d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" },
  { id: 4, label: "Refund", d: "M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" },
];

// ─── CLIENTS TAB FILTERS ──────────────────────────────────────────────────────
export const TRIP_TYPES = ["visa", "grouptrip", "privatetrip", "other"];
export const PROGRESS_STATUS = ["planning", "in_progress", "confirmed", "completed", "cancelled"];

export const statusDot = (s) =>
  ({
    in_progress: "bg-blue-400",
    confirmed: "bg-emerald-400",
    planning: "bg-sky-400",
    completed: "bg-slate-400",
    cancelled: "bg-rose-400",
  })[s] || "bg-amber-400";

// ─── HELPERS ──────────────────────────────────────────────────────────────────

/** Convert the destinations string typed in the form → array, right before sending. */
export function normaliseDestinations(tripData) {
  if (!tripData) return tripData;
  if (typeof tripData.destinations === "string") {
    return {
      ...tripData,
      destinations: tripData.destinations
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    };
  }
  return tripData;
}

// Date fields that must be coerced to YYYY-MM-DD so <input type="date"> prefills.
const DATE_KEYS = [
  "tripStartDate", "tripEndDate", "nextPaymentDueDate", "nextFollowUpDate",
  "refundDate", "bookingDate", "departureDate", "returnDate", "checkIn",
  "checkOut", "dateSubmitted", "tourDate", "startDate", "endDate", "date",
];

const toDateInput = (v) => {
  if (!v) return "";
  const d = new Date(v);
  return isNaN(d.getTime()) ? "" : d.toISOString().split("T")[0];
};

const fixDates = (obj) => {
  if (!obj || typeof obj !== "object") return obj;
  const out = Array.isArray(obj) ? [] : {};
  for (const [k, val] of Object.entries(obj)) {
    if (DATE_KEYS.includes(k)) out[k] = toDateInput(val);
    else if (val && typeof val === "object") out[k] = fixDates(val);
    else out[k] = val;
  }
  return out;
};

/** Take a stored trip subdocument and shape it for the trip wizard (dates + safe defaults). */
export function tripToFormData(trip) {
  const t = fixDates(JSON.parse(JSON.stringify(trip || {})));
  return {
    ...t,
    payment: { currency: BRAND.currency, ...(t.payment || {}) },
    refund: t.refund || { refundRequested: false },
  };
}

/** Short human label for a trip used in the trip switcher pills. */
export function tripLabel(trip, i) {
  const dests = Array.isArray(trip?.destinations) ? trip.destinations.filter(Boolean) : [];
  if (dests.length) return dests.slice(0, 2).join(", ");
  if (trip?.tripType) return trip.tripType.replace(/_/g, " ");
  return `Trip ${i + 1}`;
}

// ─── CURRENCIES (shared list for selectors) ───────────────────────────────────
export const CURRENCIES = [
  { value: "USD", label: "USD – US Dollar" },
  { value: "NGN", label: "NGN – Nigerian Naira" },
  { value: "GBP", label: "GBP – British Pound" },
  { value: "EUR", label: "EUR – Euro" },
  { value: "AED", label: "AED – UAE Dirham" },
  { value: "GHS", label: "GHS – Ghanaian Cedi" },
  { value: "KES", label: "KES – Kenyan Shilling" },
  { value: "ZAR", label: "ZAR – South African Rand" },
  { value: "CAD", label: "CAD – Canadian Dollar" },
  { value: "AUD", label: "AUD – Australian Dollar" },
];

// ─── MULTI-CURRENCY PAYMENT HELPER ────────────────────────────────────────────
/**
 * Effective amount paid in the trip's BASE currency.
 * = directly-entered base payments (amountPaidToDate)
 *   + the base-currency equivalents of any foreign-currency payments.
 * This keeps a single source of truth: amountPaidToDate stays the base figure,
 * and additionalPayments[].amountInBase are layered on top for tracking.
 */
export function effectivePaid(payment) {
  if (!payment) return 0;
  const base = Number(payment.amountPaidToDate) || 0;
  const extra = (payment.additionalPayments || []).reduce(
    (sum, p) => sum + (Number(p?.amountInBase) || 0),
    0
  );
  return base + extra;
}

// ─── TRIP TEMPLATE MAPPING ────────────────────────────────────────────────────
// The standalone trip package collection (CrmTrip in `crm_trips`) and a client's
// embedded trips[] subdocument use DIFFERENT vocabularies. These map a CrmTrip
// onto the client-trip shape so an existing trip package can prefill a client trip.
//
//   CrmTrip.tripType : private | group | adventure | pilgrimage | cruise | other
//   client tripType  : visa | grouptrip | privatetrip | other
//
//   CrmTrip.status       : planning | confirmed | ongoing  | completed | cancelled
//   client progressStatus: planning | confirmed | in_progress | completed | cancelled
export const TRIP_TYPE_MAP = {
  private: "privatetrip",
  group: "grouptrip",
  // No client-side equivalent for these — fall back to "other" (user can change it).
  adventure: "other",
  pilgrimage: "other",
  cruise: "other",
  other: "other",
};

export const TRIP_STATUS_MAP = {
  planning: "planning",
  confirmed: "confirmed",
  ongoing: "in_progress", // the only genuine rename
  completed: "completed",
  cancelled: "cancelled",
};

const isoDay = (d) => (d ? String(d).slice(0, 10) : "");

/**
 * Convert a CrmTrip package into the client-trip fields it can prefill.
 * Deliberately returns ONLY the shared descriptive fields — payment, refund and
 * per-service bookings stay per-client and are never copied from a template.
 */
export function tripTemplateToTripData(t) {
  if (!t) return {};
  return {
    destinations: (t.destinations || []).join(", "),
    tripType: TRIP_TYPE_MAP[t.tripType] || "other",
    progressStatus: TRIP_STATUS_MAP[t.status] || "planning",
    tripStartDate: isoDay(t.startDate),
    tripEndDate: isoDay(t.endDate),
    // Links the client's trip to the package: status changes on the Trips tab flow to it,
    // and the client is added to the package's members automatically.
    tripPackageId: t._id,
  };
}

/**
 * Which of a client's trips belongs to a trip package (Trips tab). Same rules as the backend:
 * an explicit tripPackageId link first, else one unambiguous match on start date, then on
 * destination. Returns -1 when unsure.
 */
export function findTripIndexForPackage(trips = [], pkg) {
  if (!pkg) return -1;
  const id = String(pkg._id);
  const linked = trips.findIndex((t) => t?.tripPackageId === id);
  if (linked !== -1) return linked;
  const day = (d) => (d ? String(d).slice(0, 10) : "");
  const unlinked = trips.map((t, i) => ({ t, i })).filter(({ t }) => !t?.tripPackageId);
  const byDate = unlinked.filter(({ t }) => pkg.startDate && day(t.tripStartDate) === day(pkg.startDate));
  if (byDate.length === 1) return byDate[0].i;
  const words = (pkg.destinations || []).map((d) => String(d).toLowerCase()).filter(Boolean);
  const byDest = (byDate.length ? byDate : unlinked).filter(({ t }) =>
    (t.destinations || []).some((d) => words.some((w) =>
      String(d).toLowerCase().includes(w) || w.includes(String(d).toLowerCase()))));
  return byDest.length === 1 ? byDest[0].i : -1;
}